import { portalApi } from "api/rtkApi";
import { SERVICES } from "constants/environment";

import type {
  CredentialRequestOptionsJSON,
  PublicKeyCredentialWithAssertionJSON,
} from "@github/webauthn-json";

type PostInitializeSCALoginRequest = {
  bearerToken: string;
};

type PostInitializeSCALoginResponse = CredentialRequestOptionsJSON;

type PostFinalizeSCALoginRequest = {
  credential: PublicKeyCredentialWithAssertionJSON;
  bearerToken: string;
};

type PostFinalizeSCALoginResponse = {
  token: string;
};

const extendedApi = portalApi.injectEndpoints({
  endpoints: (build) => ({
    initializeSCALogin: build.mutation<
      PostInitializeSCALoginResponse,
      PostInitializeSCALoginRequest
    >({
      query: ({ bearerToken }) => ({
        url: "/sca/login/initialize",
        body: {},
        method: "POST",
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }),
      extraOptions: {
        service: SERVICES.USERS,
        ignoreAuthorizationInterception: true,
      },
    }),

    finalizeSCALogin: build.mutation<
      PostFinalizeSCALoginResponse,
      PostFinalizeSCALoginRequest
    >({
      query: ({ credential, bearerToken }) => ({
        url: "/sca/login/finalize",
        body: credential,
        method: "POST",
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }),
      extraOptions: {
        service: SERVICES.USERS,
        ignoreAuthorizationInterception: true,
      },
    }),
  }),
});

export const { useInitializeSCALoginMutation, useFinalizeSCALoginMutation } =
  extendedApi;
